import * as React from 'react';
import { useCallback } from 'react';
const useLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
export const useEvent = (fn) => {
    const ref = React.useRef(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });
    useLayoutEffect(() => {
        ref.current = fn;
    });
    return useCallback((...args) => ref.current(...args), []);
};
//# sourceMappingURL=useEvent.js.map